
<t-row>
  <t-column><a :href="url" target="_blank">{{ filename }}</a></t-column>
  <t-column>{{ fileType }}</t-column>
  <t-column>{{ fileSize }}</t-column>
  <t-column>{{ uploadDate }}</t-column>
</t-row>
